@if (!loaded) {
  <app-visionnaire-loader class="ipe:w-full" />
}

@if (loaded) {
  <app-modal-container
    [title]="(editMode ? 'MODIFICA_MODELLO' : 'NUOVO_MODELLO') | translate"
    (closeButton)="closeDialog()"
  >
    <div class="message-template-modal">
      <form [formGroup]="messageTemplateDataForm" class="message-template-modal__form">
        <div class="message-template-modal__body">
          <section class="message-template-section">
            <div class="message-template-section__grid">
              <app-input
                formControlName="label"
                [withBorder]="true"
                labelStyle="bold"
                [label]="'generics.cols.label' | translate"
                type="text"
              ></app-input>
            </div>
          </section>
          <section class="message-template-section">
            <div
              class="message-template-editor"
              [class.message-template-editor--invalid]="messageTemplateDataForm.get('bodyHtml')?.invalid && messageTemplateDataForm.get('bodyHtml')?.touched"
            >
              <div class="message-template-editor__label">
                {{ 'generics.cols.body' | translate }}
                <span>*</span>
              </div>

              <div class="message-template-editor__surface">
                <quill-editor
                  #editor
                  formControlName="bodyHtml"
                  [modules]="editorConfig"
                ></quill-editor>
              </div>
            </div>
          </section>

          <section class="message-template-section message-template-section--compact">
            <div class="message-template-share">
              <div class="message-template-share__copy">
                <span class="message-template-share__title">
                  {{ 'CRM.PREFERENCES.sharedTemplateDesc' | translate }}
                </span>
                <span class="message-template-share__text">
                  {{ 'crm.pages.message.template.message.template.rendiQuestoTemplateDisponibileAnchePerAltriUtenti' | translate }}
                </span>
              </div>

              <mat-checkbox formControlName="shared"></mat-checkbox>
            </div>
          </section>
        </div>

        <div class="message-template-modal__footer">
          <button
            type="button"
            class="message-template-modal__btn message-template-modal__btn--secondary"
            (click)="closeDialog()"
          >
            {{ 'ANNULLA' | translate }}
          </button>

          <button
            type="button"
            class="message-template-modal__btn message-template-modal__btn--primary"
            [disabled]="messageTemplateDataForm.invalid || (!editable && editMode)"
            (click)="confirm()"
          >
            {{ 'CONFERMA' | translate }}
          </button>
        </div>
      </form>
    </div>
  </app-modal-container>
}
